<template>
	<div>
		<div class="col-md-12 no-padding">
			<h3 style="margin-top:0px;marin-bottom:5px;">ВЫБРАТЬ ДАТЫ</h3>
			<div class="form-group col-md-3" style="padding-left:0px;">
				<label for="outDate">Категория номера:</label>
				<select class="form-control" v-model="currentCategory">
					<option v-for="one in sortByOrder(tplData.list.categories)" :value="one">{{one.name}}</option>
				</select>
			</div>
			<div class="form-group col-md-2 no-padding">
				<label for="outDate">Дата прибытия:</label>
				<input class="form-control" type="text" id="inDate" />
			</div>
			<div class="form-group col-md-2 no-padding" style="    margin-left: 15px;">
				<label for="outDate">Дата отъезда:</label>
				<input class="form-control" type="text" id="outDate" />
			</div>
			<div class="form-group col-md-1 no-padding w10" style="    margin-left: 15px;">
				<label>Этаж:</label>
				<select class="form-control" v-model="floor">
					<option :value="{'link': '', 'value': ''}">Все</option>
					<option v-for="floor in floors" :value="{'link': floor._id, 'value': floor.name}">{{floor.name}}</option>
				</select>
			</div>
			<div class="form-group col-md-2 ">
				<label>Взрослые:</label>
				<select class="form-control" v-model="adults">
					<option v-for="one in 5" :value="one">{{one}}</option>
				</select>
			</div>
			<div class="form-group col-md-1 w10" style="padding:0px;">
				<label>Дети:</label>
				<select class="form-control" v-model="childs">
					<option value="0">Нет</option>
					<option v-for="one in 5" :value="one">{{one}}</option>
				</select>
			</div>
			<div class="col-md-12 no-padding">
				<h4 style="margin-top: 0px;"><b>Расчётный час в гостинице: 12:00</b></h4>
				<h4>Доступные номера на выбранные даты:</h4>
				<div class="col-md-12 no-padding" style="margin-bottom:5px;">
					<div v-for="one in floors" v-if="((floor.link) ? (floor.link == one._id) : true)">
						<h4>{{one.name}} этаж</h4>
						<div class="number-hot" v-for="room in sortByName(rooms)" v-if="room.floor.link == one._id" :class="{'active' : room._id == currentRoom._id}" @click="setCurRoom(room)">{{room.name}}</div>
						<hr>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12 no-padding">
			<h3 style="margin-bottom:20px;">Личная Информация</h3>
			<div class="form-group col-md-12 no-padding">
				<label class="col-sm-3 control-label" style="padding-left:0px;">Имя</label>
				<div class="col-sm-9 no-padding">
					<input class="form-control" v-model="guest.givenName" type="text">
				</div>
			</div>
			<div class="form-group col-md-12 no-padding">
				<label class="col-sm-3 control-label" style="padding-left:0px;">Фамилия</label>
				<div class="col-sm-9 no-padding">
					<input class="form-control" v-model="guest.familyName" type="text">
				</div>
			</div>
			<div class="form-group col-md-12 no-padding">
				<label class="col-sm-3 control-label" style="padding-left:0px;">Отчество</label>
				<div class="col-sm-9 no-padding">
					<input class="form-control" v-model="guest.additionalName" type="text">
				</div>
			</div>
			

		</div>
		<div class="col-md-12 no-padding">
			
			<div class="form-group col-md-12 no-padding">
				<label class="col-sm-3 control-label" style="padding-left:0px;">Телефон</label>
				<div class="col-sm-9 no-padding">
					<input class="form-control" v-model="guest.phone" type="text">
				</div>
			</div>
			<div class="form-group col-md-12 no-padding">
				<label class="col-sm-3 control-label" style="padding-left:0px;">Email</label>
				<div class="col-sm-9 no-padding">
					<input class="form-control" v-model="guest.email" type="text">
				</div>
			</div>
		</div>
		<div class="col-md-12 no-padding">
			<h3>Пожелания и примечания:</h3>
			<div class="form-group">
				<textarea class="form-control" rows="5" v-model="guest.description" id="comment"></textarea>
			</div>
		</div>
		<div class="col-md-12 no-padding">
			<!--<label class="checkbox-inline"><input type="checkbox" value="" v-model="guest.success">Да, я прочитал и согласен с условиями бронирования</label><br>-->
			<a href="#" class="booking-btn1" style="margin-top: 16px;" @click.prevent.stop="bookIt">ЗАБРОНИРОВАТЬ</a>
		</div>
	</div>
</template>

<script>
import toastr from 'toastr'

function parseDate (s) {
	if (typeof(s) == 'string') {
		var b = s.split(/\D+/);
		return new Date(b[2], --b[0], b[1]);
	}
	if (typeof(s) == 'object') {
		return new Date(s);
	}
	return new Date();
}
import Vue from 'vue'
export default {
	name: 'booking',
	data() {
		return {
			currentCategory: this.$parent.tplData.main,
			tplData: this.$parent.tplData,
			floor: {link: '', value: ''},
			floors: [],
			currentRoom: {},
			nights: 1,
			childs: 0,
			adults: 1,
			guest: {
				"givenName": "",
				"familyName": "",
				"additionalName": "",
				phone: '',
				email: '',
				description: '',
				passport: {
					dateOfIssue: '',
					address: '',
					byWhom: '',
					sn: ''
				}
			},
			start: '',
			apiBysi: false,
			inDate: null,
			outDate: null,
			rooms: [],
			startDateInput: '',
			endDateInput: ''
		}
	},
	created: function () {
		this.setAllowedFloors();
		var now = new Date(); 
		var now2 = new Date((new Date()).setDate(new Date().getDate()+1));
		this.startDateInput = ''+('0'+(now.getMonth()+1)).substr(-2)+'-'+('0'+now.getDate()).substr(-2)+'-'+now.getFullYear();
		this.endDateInput = ''+('0'+(now2.getMonth()+1)).substr(-2)+'-'+('0'+now2.getDate()).substr(-2)+'-'+now2.getFullYear();
		this.updateRooms();
	},
	mounted(){
		Vue.nextTick(()=>{
			try {
				this.initCalendars();
			} catch(e) {
				console.log(e)
			}
		});
	},
	watch: {
		'startDateInput'() {
			this.updateRooms();
		},
		'endDateInput'() {
			this.updateRooms();
		},
		'tplData': {
			deep: true,
			handler(val) {
				this.setAllowedFloors();
				this.updateRooms();
			}
		},
		'currentCategory': {
			deep: true,
			handler(val) {
				this.$emit('catChange', val);
				try {
					this.updateData();
				} catch (e){}
			}
		},
		'rooms': {
			deep: true,
			handler: function (val) {
				if (val && val[0]) {
					this.currentRoom = val[0];
				}
			}
		}
	},
	computed: {
		booked: function () {
			var obj = {};
			if (this.tplData.list && this.tplData.list.rooms && this.tplData.list.rooms.length >0) {
				for(var i=0;i < this.tplData.list.rooms.length;i++) {
					var room = this.tplData.list.rooms[i];
					if (room && room._id) {
						obj[room._id] = [];
					}
				}
				if (this.tplData.list.booking && this.tplData.list.booking.length > 0) {
					for(var j=0;j < this.tplData.list.booking.length;j++) {
						var book = this.tplData.list.booking[j];
						if (book && book.room && book.room.link && obj[book.room.link]) {
							obj[book.room.link].push(book);
						}
					}	
				}
				for(var key in obj) {
					if (!(obj[key] && (obj[key].length > 0))) {
						delete obj[key];
					}
				}
			}
			return obj;
		},
		startDate: function (_date) {
			var date;
			if (_date) {
				date = new Date((new Date()).setDate(new Date().getDate()));
			} else {
				date = new Date((_date).setDate(_date.getDate()));
			}
			return ('0'+date.getDate()).substr(-2)+'.'+('0'+(date.getMonth()+1)).substr(-2)+'.'+date.getFullYear();
		},
		endDate: function () {
			var date = new Date((new Date()).setDate(new Date().getDate() + 1));
			return ('0'+date.getDate()).substr(-2)+'.'+('0'+(date.getMonth()+1)).substr(-2)+'.'+date.getFullYear();
		},
		floorschema: function() {
			var i=0; 
			var toRet = '';
			while(i < this.floors.length) {
				if (this.floors[i] && (this.floors[i]._id == this.floor.link)) {
					if (this.floors[i].image && this.floors[i].image[0]) {
						toRet = this.floors[i].image[0];
					}
					break;
				}
				i++;
			}
			return toRet;
		},
		// rooms: function() {
		// 	var toRet = [];
		// 	for (var i=0; i < this.tplData.list.rooms.length;i++) {
		// 		var room = this.tplData.list.rooms[i];
		// 		if (room && room.floor && room.floor.link == this.floor.link) {
		// 			toRet.push(room);
		// 		} else {
		// 			continue;
		// 		}
		// 	}
		// 	toRet.sort(function(a, b) {
		// 		return ((a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0));
		// 	})
		// 	return toRet;
		// }
	},
	methods: {
		setCurRoom(room){
			if (room.busy) {
				toastr.error('Номер на эту дату уже забронирован!');
				return false;
			}
			this.currentRoom = room;
		},
		updateRooms() {
			var rooms = JSON.parse(JSON.stringify(this.tplData.list.rooms));
			var reservs = JSON.parse(JSON.stringify(this.tplData.list.booking));
			var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			var firstDate = new Date(this.startDateInput);
			var secondDate = new Date(this.endDateInput);

			var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
			var arrDates = [];
			var i = 0;
			for (i=0; i < diffDays;i++) {
				var startDate = new Date(firstDate.toISOString());
				startDate = new Date((startDate).setDate(startDate.getDate() + i));
				arrDates.push(('0'+(startDate.getMonth()+1)).substr(-2)+'-'+('0'+startDate.getDate()).substr(-2)+'-'+startDate.getFullYear());
			}
			var allowedrooms = [];
			for (i=0; i < rooms.length; i++) {
				let busy = false;
				let room = rooms[i];
				let _booked = this.booked[room._id];
				if (_booked && _booked.length > 0) {
					let j = 0;
					while(j < _booked.length) {
						let one = _booked[j];
						let k = 0;
						if (busy) {
							break;
						}
						while(k < one.dates.length) {
							if (arrDates.includes(one.dates[k])) {
								busy = true;
								break;
							}
							k++;
						}
						j++;
					}
				}
				if (busy) {
					room.busy = true;
				}
				allowedrooms.push(room);
			}
			this.rooms = allowedrooms;
		},
		updateData() {
			let url = this.currentCategory.urlId;
			$.get('/'+url+'?json=1')
			.done((data)=>{
				this.tplData = data;
			})
		},
		initCalendars() {
			var self = this;
			var locale = {
				"format": "DD/MM/YYYY",
				"separator": " - ",
				"applyLabel": "Apply",
				"cancelLabel": "Cancel",
				"fromLabel": "From",
				"toLabel": "To",
				"customRangeLabel": "Custom",
				"weekLabel": "Н",
				"daysOfWeek": [
					"Вс",
					"Пн",
					"Вт",
					"Ср",
					"Чт",
					"Пт",
					"Сб"
				],
				"monthNames": [
					"Январь",
					"Февраль",
					"Март",
					"Апрель",
					"Май",
					"Июнь",
					"Июль",
					"Август",
					"Сентябрь",
					"Октябрь",
					"Ноябрь",
					"Декабрь"
				],
				"firstDay": 1
			}
			$('#inDate').daterangepicker({
				locale: locale,
				singleDatePicker: true,
				"minDate": new Date(),
				"maxDate":  new Date((new Date()).setDate(new Date().getDate()+60))
			}, function(start, end, label) {
				var str = ''+('0'+(start._d.getMonth()+1)).substr(-2)+'-'+('0'+start._d.getDate()).substr(-2)+'-'+start._d.getFullYear();
				self.startDateInput = str;
				let _thisDate = new Date(str);
				let _secondDate = new Date(self.endDateInput);
				if (_thisDate.getTime() > _secondDate.getTime()) {
					self.outDate.setStartDate(new Date(_thisDate.setDate(_thisDate.getDate()+1)));
				}
			});
			this.inDate = $('#inDate').data('daterangepicker');
			$('#outDate').daterangepicker({
				locale: locale,
				singleDatePicker: true,
				"startDate": new Date((new Date()).setDate(new Date().getDate()+1)),
				"minDate": new Date((new Date()).setDate(new Date().getDate()+1)),
				"maxDate":  new Date((new Date()).setDate(new Date().getDate()+60))
			}, function(start, end, label) {
				var str = ''+('0'+(start._d.getMonth()+1)).substr(-2)+'-'+('0'+start._d.getDate()).substr(-2)+'-'+start._d.getFullYear();
				self.endDateInput = str;
				let _thisDate = new Date(str);
				let _prevDate = new Date(self.startDateInput);
				if (_thisDate.getTime() < _prevDate.getTime()) {
					self.inDate.setStartDate(new Date(_thisDate.setDate(_thisDate.getDate()-1)));
				}
			});
			this.outDate = $('#outDate').data('daterangepicker');
		},
		_startDate: function (_date) {
			var date;
			if (!_date) {
				date = new Date((new Date()).setDate(new Date().getDate()));
			} else {
				date = new Date((_date).setDate(_date.getDate()));
			}
			return ('0'+date.getDate()).substr(-2)+'.'+('0'+(date.getMonth()+1)).substr(-2)+'.'+date.getFullYear();
		},
		sortByOrder: function (arr) {
			return Array.prototype.sort.call(arr, function (one, two) {
				if (one.sortOrder > two.sortOrder) {
					return 1;
				}
				if (one.sortOrder < two.sortOrder) {
					return -1;
				}
				return 0;
			});
		},
		sortByName: function (arr) {
			return Array.prototype.sort.call(arr, function (one, two) {
				if (one.name > two.name) {
					return 1;
				}
				if (one.name < two.name) {
					return -1;
				}
				return 0;
			});
		},
		bookIt: function() {
			console.log(this.apiBysi);
			if (this.apiBysi) {
				return;
			}
			this.apiBysi = true;
			var obj = {};
			obj.passport = {
				"givenName": this.guest.givenName,
				"familyName": this.guest.familyName,
				"additionalName": this.guest.additionalName,
				"address":  this.guest.passport.address,
				"byWhom": this.guest.passport.byWhom,
				"dateOfIssue": this.guest.passport.dateOfIssue,
				"image1":"",
				"image2":"",
				"sn": this.guest.passport.sn,
				"phone": this.guest.phone,
				"email": this.guest.email,
				"description": this.guest.description
			};
			obj.adults = this.adults;
			obj.childs = this.childs;
			obj.date1 = this.startDateInput;
			obj.date2 = this.endDateInput;
			var room = JSON.parse(JSON.stringify(this.currentRoom));
			obj.room = {
				"link": room._id,
				"value": room.name
			};
			obj.floor = room.floor;
			obj.category = room.category;
			obj.dates = [];
			var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			var firstDate = new Date(obj.date1);
			var secondDate = new Date(obj.date2);
			var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
			for (var i=0; i < diffDays;i++) {
				var startDate = new Date(firstDate.toISOString());
				startDate = new Date((startDate).setDate(startDate.getDate() + i));
				obj.dates.push(('0'+(startDate.getMonth()+1)).substr(-2)+'-'+('0'+startDate.getDate()).substr(-2)+'-'+startDate.getFullYear());
			}
			obj.reactValue = 0
			console.log(obj);
			
			if (!obj.passport.givenName) {
				toastr.warning('Укажите Имя!');
				this.apiBysi = false;
				return;
			}
			if (!obj.passport.familyName) {
				toastr.warning('Укажите Фамилию!');
				this.apiBysi = false;
				return;
			}
			if (!obj.passport.additionalName) {
				toastr.warning('Укажите Отчество!');
				this.apiBysi = false;
				return;
			}
			if (!obj.passport.phone) {
				toastr.warning('Укажите номер телефона!');
				this.apiBysi = false;
				return;
			}
			if (!obj.passport.email) {
				toastr.warning('Укажите номер email!');
				this.apiBysi = false;
				return;
			}
			if (!obj.room.link) {
				toastr.warning('Выберите номер!');
				this.apiBysi = false;
				return;
			}
			$.ajax({
				url: '/editor',
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({newObj: obj, schema:'booking'})
			})
			.done((resp)=>{
				if(resp.success) {
					this.sendMail(obj);
				}
				console.log(resp)
			});
		},
		sendMail(obj) {
			var humanDate = function (_date) {
				var date = new Date(_date);
				return ('0'+date.getDate()).substr(-2)+'.'+('0'+(date.getMonth()+1)).substr(-2)+'.'+date.getFullYear();
			};
			var html = '<div>';
			html+= '<h4>Имя:</h4><p>'+obj.passport.givenName+'</p>';
			html+= '<h4>Фамилия:</h4><p>'+obj.passport.familyName+'</p>';
			html+= '<h4>Отчество:</h4><p>'+obj.passport.additionalName+'</p>';
			html+= '<h4>Телефон:</h4><p>'+obj.passport.phone+'</p>';
			html+= '<h4>Email:</h4><p>'+obj.passport.email+'</p>';
			html+= '<h4>примечание:</h4><p>'+obj.passport.description+'</p>';
			html+= '<h4>Номер:</h4><p>'+obj.room.value+'</p>';
			html+= '<h4>Дата прибытия:</h4><p>'+humanDate(obj.date1)+'</p>';
			html+= '<h4>Дата отъезда:</h4><p>'+humanDate(obj.date2)+'</p>';
			html+= '<h4>Взрослых:</h4><p>'+obj.adults+'</p>';
			html+= '<h4>Детей:</h4><p>'+obj.childs+'</p></div>';
			var out = {
				html: html,
				target: 'komfort.armavir@mail.ru'
			};
			$.post('/sendmail', out)
				.done(function(data){
					console.log(data);
					if (data.success) {
						toastr.info('Заявка успешно отправлена, вскоре с вами свяжется администратор отеля для уточнения информации!');
						setTimeout(function(){
							location.href='/';
						},1000)
					}
					this.apiBysi = false;
				});
		},
		setDay2: function(msg) {
			this.start = this._startDate(msg);
		},
		setDay: function(msg) {
			this.start = this._startDate(msg);
		},
		setAllowedFloors: function () {
			var floors = [];
			for (var i=0; i < this.tplData.list.floors.length;i++) {
				var floor = this.tplData.list.floors[i];
				var j = 0;
				while(j < this.tplData.list.rooms.length) {
					var room = this.tplData.list.rooms[j];
					if (room.floor && room.floor.link && (floor._id == room.floor.link)) {
						floors.push(floor);
						break;
					}
					j++;
				}
			}
			floors.sort(function(a, b) {
				return ((a.sortOrder < b.sortOrder) ? -1 : ((a.sortOrder > b.sortOrder) ? 1 : 0));
			});
			this.floor = {link: '', value: ''};
			this.floors = floors;
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Booking.vue?3b4b3f02